<template>
    <div>
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''"
        >
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>
        <!--end::Label-->

        <template v-if="item.type == 'File'">
            <!--begin::Input-->
            <Field class="form-control form-control-lg form-control-solid"
                   type="file"
                   :name=" item.model_key + item.key"
                   :rules="$helpers.getValidationRules(item)"
                   @change='handleChangeImage($event)'
                   :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                   autocomplete="off"
            />
            <!--end::Input-->
        </template>

        <template v-if="item.type == 'Image'">
            <!--begin::Input-->
            <Field class="form-control form-control-lg form-control-solid"
                   type="file"
                   @change='handleChangeImage($event)'
                   :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                   :rules="$helpers.getValidationRules(item)"
                   :name=" item.model_key + item.key"
                   :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                   autocomplete="off"
                   accept='image/jpeg, image/png, image/jpg'
            />
            <!--end::Input-->
        </template>

        <div class='d-flex flex-column w-100 me-2 mb-5'
             v-if='LoaderProgress'>
            <div class='d-flex flex-stack mb-2'><span
                    class='text-muted me-2 fs-7 fw-bold'>{{ LoaderProgress }}% </span>
            </div>
            <div class='progress h-6px w-100'>
                <div class='progress-bar bg-danger progress-bar-striped progress-bar-animated'
                     role='progressbar'
                     :aria-valuenow='LoaderProgress'
                     aria-valuemin='0' aria-valuemax='100'
                     :style="{width: LoaderProgress+'%'}"></div>
            </div>
        </div>
        <!--<a v-if="file" :href="file" target="_blank" class="fs-6 text-primary">-->
        <!--{{$t('show_image')}}-->
        <!--</a>-->
        <div>
            <a v-if="item.value" :href="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+item.value)" target="_blank"
               class="fs-6 text-primary">
                {{$t('show_current')}}
            </a>
        </div>

        <Field v-model="item.value"
               :name=' item.model_key + item.key'
               type="hidden"
               class="d-none"/>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<span class="text-dark">({{item.type}})</span>-->
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-muted">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-muted">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>
        <!--validation errors -->
        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<ErrorMessage :name="item.model_key + item.key"/>-->
                <ErrorMessage :name="item.model_key + item.key" v-slot="{ message }">
                    <template v-if="item.validation_error_msg_ar  && i18n.locale.value == 'ar'">
                        <slot>
                            {{item.validation_error_msg_ar}}
                        </slot>
                    </template>
                    <template v-if="item.validation_error_msg  && i18n.locale.value == 'en'">
                        <slot>
                            {{item.validation_error_msg}}
                        </slot>
                    </template>
                    <template
                            v-if="!(item.validation_error_msg_ar  && i18n.locale.value == 'ar')  && !(item.validation_error_msg  && i18n.locale.value == 'en')">
                        <slot>
                            {{message}}
                        </slot>
                    </template>
                </ErrorMessage>
            </div>
        </div>
        <!--<div class="fv-plugins-message-container">-->
        <!--<div class="fv-help-block bg-primary text-white p-1">-->
        <!--{{$helpers.getValidationRules(item)}}-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script lang="ts">
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormFileInput',
    components: {
      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();
      const store = useStore();
      const router = useRouter();

      let currentItem: any = props.item;
      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,

        file: null,
        FileModel: null,
        LoaderProgress: 0,
        FileLoader: false,
      });

      const triggerClickUpdate = () => {
        let element = document.getElementById('imageFile');
        if (element) element.click();
      };
      const handleChangeImage = (evt: Event | any) => {
        let file = evt.target.files[0];
        let payload = new FormData();
        payload.append('path', 'FormFile');
        payload.append('isPublic', 'false');
        if(helpers.getUserId()) payload.append('userId', helpers.getUserId());
        payload.append('files', file);
        state.FileModel = file;
        uploadImage(payload);
      };
      const uploadImage = (payload) => {
        state.FileLoader = true;
        state.item.value = null
        state.LoaderProgress = 0;
        let config: any = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function(progressEvent) {
            let uploadPercentage: number = (Math.round(((progressEvent.loaded / progressEvent.total) * 100)));
            state.LoaderProgress = uploadPercentage;
          },
        };
        let requestData = {
          formData: payload,
          config: config,
          storageKey: 'FormFile',
        };
        setTimeout(() => {
          store.dispatch('moduleCommon/uploadImage', requestData).then(({ data }) => {
            state.FileLoader = false;
            state.file = data.filesUrls[0];
            if (state.item) {
              if (data.filesUrls[0]) {
                const queryString = (new URL(data.filesUrls[0])).search;
                const urlParams = new URLSearchParams(queryString);
                let filePath:any = urlParams.get('filePath');
                state.item.value = filePath;
              }
            }
            setTimeout(() => {
              state.LoaderProgress = 0;
            }, 1000);
          }).catch((response) => {
            state.FileLoader = false;
            state.LoaderProgress = 0;
            helpers.handleResponse(response, i18n.t, router, store);
          });
        }, 10);
      };

      return {
        handleChangeImage,
        ...toRefs(state),
        i18n, store,
        helpers,
      };
    },
  });
</script>
